/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { StaticQuery, graphql } from "gatsby"

import Header from "./header"
import "./layout.css"

import { createGlobalStyle, ThemeProvider } from "styled-components"
import { reset, themes, AppBar, Toolbar } from "react95"

const ResetStyles = createGlobalStyle`
  ${reset}
`

const Layout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => (
      <>
        <div className="App">
          <ResetStyles />
          <ThemeProvider theme={themes.default}>
            <>
              {/* <Header siteTitle={data.site.siteMetadata.title} /> */}
              <AppBar style={{ zIndex: 999999}}>
                <Toolbar style={{ justifyContent: "space-between",padding: 20 }}>
                  <marquee scrollamount="10" loop="1"><h1 style={{ fontWeight: "bold"}}> Hello, Nice to meet you ! 🦊, My Name is Nyan Win. Please check below to know more about me ! </h1></marquee>
                </Toolbar>
              </AppBar>
      
              <div
                style={{
                  margin: `0 auto`,
                  maxWidth: 960,
                  padding: `0px 1.0875rem 1.45rem`,
                  marginTop: 60,
                }}
              >
                <main>{children}</main>
              </div>
            </>
          </ThemeProvider>
        </div>
      </>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
